import { createEnum } from '@oahz/neact-openapi'
import type * as defs from './api'
export type { defs }
import * as apiService from './api'

export const enums = {}

class BizService {
  supplierTagCatTree = async (params: { keyword?: string } = {}) => {
    const res = await apiService.supplierTagCatTree()

    type Item = typeof res['data']['cats'][number]
    type RItem = Item & { key: number, title: string, fullname: string, children?: RItem[] }
    
    let total = 0
    const datamap: Record<number, RItem> = {}

    const filtering = (v: Item, keyword: string): Item | undefined => {
      const children = v.children_cats && v.children_cats.filter((t) => filtering(t, keyword))
      if (v.name.includes(keyword) || children?.length) {
        return { ...v, children_cats: children }
      } else {
        return undefined
      }
    }

    const mapping = (v: Item, parentName?: string): RItem => {
      total += (v.tag_num || 0)
      const fullname = parentName ? `${parentName}/${v.name}` : v.name
      const rtn = {
        ...v,
        key: v.id,
        title: `${v.name}（${v.tag_num || 0}）`,
        fullname,
        children: v.children_cats && v.children_cats.map((t) => mapping(t, fullname)),
      };
      datamap[rtn.key] = rtn
      return rtn
    };

    let cats =  res?.data?.cats || []
    if (params.keyword) {
      cats = cats.filter(v => filtering(v, params.keyword))
    }

    return {
      ...res,
      data: {
        ...res.data,
        cats: cats.map(v => mapping(v)),
        datamap,
        dataarr: Object.values(datamap),
        total,
      },
    }
  }
}

export default new BizService()